import { AccountHolderWalkthroughSteps, DONE, NewAccountWalkthroughSteps } from '@/types/walkthroughs';
import { AppDispatch } from '@/redux/store';
import { setOnboardingWalkthroughStep } from '@/redux/modules/walkthroughs/walkthroughs.reducer';

export const firstTimeWalkthroughSkip = (dispatch: AppDispatch) => () =>
    dispatch(setOnboardingWalkthroughStep(AccountHolderWalkthroughSteps.Returning));
export const accountHolderWalkthroughSkip = (dispatch: AppDispatch) => () =>
    dispatch(setOnboardingWalkthroughStep(NewAccountWalkthroughSteps.FirstTimeAnyPage));
export const newAccountWalkthroughSkip = (dispatch: AppDispatch) => () => dispatch(setOnboardingWalkthroughStep(DONE));
